import { convertCentsToDollars, removeDecimals, floor } from './monetary-helpers';

const getPointsValue = (input: number): string => removeDecimals(floor(Number(convertCentsToDollars(input))));

export { getPointsValue };
